import React from 'react';
import { PersonalInfo } from '../types';
import SocialLinks from './SocialLinks';
import { useTypewriter } from '../hooks/useTypewriter';

interface HeroProps {
  personalInfo: PersonalInfo;
}

const Hero: React.FC<HeroProps> = ({ personalInfo }) => {
  const { displayText: typedName } = useTypewriter({
    text: personalInfo.name,
    delay: 50,
    startDelay: 500
  });

  return (
    <section id="home" className="hero">
      <div className="hero-content">
        <div className="hero-text">
          <h1 className="hero-title">
            Hi, I'm <span className="gradient-text">S{typedName}</span>
          </h1>
          <p className="hero-subtitle">{personalInfo.subtitle}</p>
          <p className="hero-description">{personalInfo.description}</p>
          <div className="hero-buttons">
            <a href="#projects" className="btn btn-primary">View Projects</a>
            <a href="#contact" className="btn btn-secondary">Get in Touch</a>
          </div>
          <SocialLinks personalInfo={personalInfo} />
        </div>
        <div className="hero-image">
          <div className="floating-card">
            <div className="card-content">
              <div className="code-snippet">
                <span className="code-keyword">const</span> developer = {'{'}<br />
                &nbsp;&nbsp;name: <span className="code-string">"{personalInfo.name}"</span>,<br />
                &nbsp;&nbsp;specialties: [<span className="code-string">"Data Engineering"</span>, <span className="code-string">"AI Applications"</span>],<br />
                &nbsp;&nbsp;open_to_work: <span className="code-boolean">true</span>,<br />
                {'}'};
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
